export default __webpack_public_path__ + "static/media/investors_logo5.9b29bc20.png";